"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("../../Themes/styled-components"));
var AsyncInputAutocomplete_1 = __importDefault(require("../../AsyncInputAutocomplete"));
var InputAutocomplete_1 = __importDefault(require("../../InputAutocomplete"));
// import { smarttagsPropType } from './propTypes';
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var InputSmarttag = /** @class */ (function (_super) {
    __extends(InputSmarttag, _super);
    function InputSmarttag(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: props.defaultInputValue,
        };
        _this.handleChangeValue = _this.handleChangeValue.bind(_this);
        _this.getItemLabel = _this.getItemLabel.bind(_this);
        _this.handleSelectItem = _this.handleSelectItem.bind(_this);
        return _this;
    }
    InputSmarttag.prototype.getItemLabel = function (item) {
        var title = item.title;
        if (title && title !== '') {
            return title;
        }
        return item.key;
    };
    InputSmarttag.prototype.getItems = function (availableSmarttags) {
        var value = this.state.value;
        var _a = value.split(':'), nameOfSmarttag = _a[0], valueOfSmarttag = _a[1];
        if (typeof valueOfSmarttag !== 'undefined') {
            // smarttag value is being typed  (second part of smarttag)
            // we should filter available smarttag values
            var smarttagName = availableSmarttags.find(function (smarttag) { return smarttag.key === nameOfSmarttag; });
            if (smarttagName) {
                var values = smarttagName.values.reduce(function (prev, smarttag) {
                    if (smarttag.key
                        .toLocaleLowerCase()
                        .indexOf(valueOfSmarttag.toLocaleLowerCase()) >= 0) {
                        return __spreadArrays(prev, [smarttag]);
                    }
                    return prev;
                }, []);
                if (values.length === 1) {
                    if (values[0].key === valueOfSmarttag) {
                        return [];
                    }
                }
                return values;
            }
            return [];
        }
        // typing of smarttag name (first part of smarttag)
        // we should filter available smarttags
        return availableSmarttags.reduce(function (prev, smarttag) {
            if (smarttag.key
                .toLocaleLowerCase()
                .indexOf(nameOfSmarttag.toLocaleLowerCase()) >= 0) {
                return __spreadArrays(prev, [smarttag]);
            }
            return prev;
        }, []);
    };
    /**
     * @param {string} value
     */
    InputSmarttag.prototype.handleChangeValue = function (value) {
        this.setState({ value: value });
    };
    InputSmarttag.prototype.handleSelectItem = function (item) {
        var value = this.state.value;
        var _a = this.props, onAdd = _a.onAdd, readOnly = _a.readOnly;
        if (readOnly) {
            return false;
        }
        var _b = value.split(':'), nameOfSmarttag = _b[0], valueOfSmarttag = _b[1];
        if (item === null) {
            // nothing selected
            if (typeof valueOfSmarttag !== 'undefined' &&
                valueOfSmarttag.length > 0) {
                onAdd({
                    key: nameOfSmarttag.trim(),
                    values: [{ key: valueOfSmarttag.trim() }],
                });
                this.setState({ value: '' });
                return true;
            }
            return false;
        }
        if (typeof valueOfSmarttag !== 'undefined') {
            onAdd({
                key: nameOfSmarttag,
                values: [{ key: item.key }],
            });
            this.setState({ value: '' });
            return true;
        }
        this.setState({ value: item.key + ":" });
        return false;
    };
    InputSmarttag.prototype.render = function () {
        var _this = this;
        var value = this.state.value;
        var _a = this.props, getSmarttagsKeys = _a.getSmarttagsKeys, getSmarttagsValues = _a.getSmarttagsValues, placeholder = _a.placeholder, readOnly = _a.readOnly, disabled = _a.disabled, restProps = __rest(_a, ["getSmarttagsKeys", "getSmarttagsValues", "placeholder", "readOnly", "disabled"]);
        var smarttagKey = value.split(':')[0];
        var currentValue = value.split(':')[1];
        var insertValue = value.includes(':');
        var currentGetFunc = insertValue
            ? function (valueOfSmarttag) {
                return _this.props.getSmarttagsValues(smarttagKey, valueOfSmarttag.split(':')[1]);
            }
            : getSmarttagsKeys;
        return (React.createElement(Wrapper, null, getSmarttagsKeys && getSmarttagsValues ? (React.createElement(AsyncInputAutocomplete_1.default, __assign({ placeholder: placeholder, value: value, onChange: this.handleChangeValue, onSelectItem: this.handleSelectItem, getItemLabel: this.getItemLabel, getItems: currentGetFunc, readOnly: readOnly, valid: !!currentValue, cache: true, submitAllowed: true, "data-testid": "InputSmarttag-Input" }, restProps))) : (React.createElement(InputAutocomplete_1.default, __assign({ placeholder: placeholder, value: value, onChange: this.handleChangeValue, getItemLabel: this.getItemLabel, items: this.getItems(this.props.availableSmarttags), onSelectItem: this.handleSelectItem, valid: !!currentValue, readOnly: readOnly, disabled: disabled, submitAllowed: true, "data-testid": "InputSmarttag-Input" }, restProps)))));
    };
    InputSmarttag.defaultProps = {
        onAdd: function () { },
        getSmarttagsKeys: null,
        getSmarttagsValues: null,
        availableSmarttags: [],
        placeholder: '',
        readOnly: false,
        defaultInputValue: '',
        disabled: false,
    };
    return InputSmarttag;
}(React.Component));
// InputSmarttag.propTypes = {
//   availableSmarttags: smarttagsPropType,
//   onAdd: PropTypes.func,
//   getSmarttagsKeys: PropTypes.func,
//   getSmarttagsValues: PropTypes.func,
//   placeholder: PropTypes.string,
//   readOnly: PropTypes.bool,
//   defaultInputValue: PropTypes.string,
//   disabled: PropTypes.bool,
// };
exports.default = InputSmarttag;
var templateObject_1;
